import { ValidationErrors } from 'final-form';
import { diff } from 'deep-object-diff';
import React from 'react';
import { FormSpy } from 'react-final-form';

interface OuterProps {
    debounce: number;
    save: (values: any) => Promise<any>;
    diffFn?: (oldValues: any, newValues: any) => boolean;
}

type Props = OuterProps & { values: any; errors: ValidationErrors };

interface State {
    values: any;
    submitting: boolean;
}

// Source: https://codesandbox.io/s/5w4yrpyo7k?file=/AutoSave.js:0-1500
// TODO: Rewrite to use Hooks
class AutoSaveComponent extends React.Component<Props, State> {
    timeout: NodeJS.Timeout | undefined = undefined;
    promise: Promise<any> | undefined = undefined;

    constructor(props: Props) {
        super(props);
        this.state = { values: props.values, submitting: false };
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.save, this.props.debounce);
    }

    save = async () => {
        if (this.promise) {
            await this.promise;
        }
        const { values, errors, save, diffFn } = this.props;

        if (Object.keys(errors).length > 0) {
            return;
        }

        // This diff step is totally optional
        const isDifferent = diffFn
            ? diffFn(this.state.values, values)
            : Object.keys(diff(this.state.values, values)).length > 0;
        if (isDifferent) {
            // values have changed
            this.setState({ submitting: true, values });
            this.promise = save(values);
            try {
                await this.promise;
            } catch (err) {
                console.error(err);
            }
            delete this.promise;
            setTimeout(() => this.setState({ submitting: false }), 2000);
        }
    };

    render() {
        // This component doesn't have to render anything, but it can render
        // submitting state.
        return this.state.submitting && <div>Saving...</div>;
    }
}

// Make a HOC
// This is not the only way to accomplish auto-save, but it does let us:
// - Use built-in React lifecycle methods to listen for changes
// - Maintain state of when we are submitting
// - Render a message when submitting
// - Pass in debounce and save props nicely
const AutoSave = (props: OuterProps) => (
    <FormSpy {...props} subscription={{ values: true, errors: true }}>
        {(spyProps) => (
            <AutoSaveComponent
                debounce={props.debounce}
                save={props.save}
                values={spyProps.values}
                errors={spyProps.errors}
                diffFn={props.diffFn}
            />
        )}
    </FormSpy>
);
export default AutoSave;
